<template>
  <div class="store-visit">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.storeVisit')">
    </NavHeaderBar>
    <div class="visit-form-content">
      <div class="form-item form-time-item">
        <div class="label required">
          <span class="alone-font">{{ $t('form.visitDate') }}</span>
        </div>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :disabled="true"
          :value="visitForm.visitTime"
          placeholder=""
          @click="handleCalendar"
          :border="false"
          class="custom-field"
        >
          <template #left-icon>
            <van-icon name="calendar-o" color="#b9cbed" />
          </template>
        </van-field>
        <van-popup v-model="showCalendar" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :title="$t('form.chooseDate')"
            :max-date="maxDate"
            @confirm="onConfirmDate"
            @cancel="showCalendar = false"
          />
        </van-popup>
      </div>
      <div class="form-item uploader-customer">
        <div class="label required">
          <span class="alone-font">{{ $t('form.checkInPhoto') }}</span>
        </div>
        <van-uploader v-model="visitForm.imgMap.check" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'check')" />
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('form.listingStatus')" name="1">
          <template #title>
            <div><span class="collapse-title-reuqired">*</span>{{ $t('form.listingStatus') }}</div>
          </template>
          <div class="collapse-sub">
            <div class="sub-top">
              <div class="left-title">{{ $t('form.currentProductListingStatus') }}</div>
            </div>
            <div class="sub-bottom">
              <div class="sub-listing-item">{{ $t('form.listing') }} {{ shelfInfo.listing }}</div>
              <div class="sub-listing-item not-listing-item">{{ $t('form.notListing') }} {{ shelfInfo.notListing }}</div>
              <div class="sub-listing-item end-listing-item">{{ $t('form.endOfSales') }} {{ shelfInfo.endSales }}</div>
              <div class="sub-listing-item unknown-listing-item">{{ $t('shared.filter.unknown') }} {{ shelfInfo.unknown }}</div>
            </div>
            <div class="to-detail" @click="toUrl(`/shared/shelfStatus?customerId=${visitForm.customerId}`)">{{ $t('form.listingStatus') }}></div>
          </div>
          <div class="form-item listing-form-item" :class="{'no-listing-form-item': !visitForm.isUpdateShelf}">
            <div class="label">
              <span>{{ $t('shared.titleThirtyThree') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field shelf-radio">
              <template #input>
                <van-radio-group v-model="visitForm.isUpdateShelf" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in isUpdateShelfList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-show="visitForm.isUpdateShelf" class="shelf-title">{{ $t('form.selectProductsToUpdateListingStatus') }}：</div>
          <div v-show="visitForm.isUpdateShelf" class="shelf-bc">
            <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.shelfList" :key="brandItem.projectId">
              <div class="label square">
                <span>{{ brandItem.projectName }}</span>
              </div>
              <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="product-status">
                  <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.shelfList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" />
                  <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                </div>
                <div class="product-listing">
                  <div class="listing-item">
                    <div class="listing-label">{{ $t('form.listingOrNot') }}</div>
                    <van-field class="custom-field custom-radio-field">
                      <template #input>
                        <van-radio-group v-model="subItem.isShelf" direction="horizontal">
                          <van-radio v-for="(subItem, subIndex) in listingList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                  </div>
                  <div v-if="subItem.isShelf === 1">
                    <div class="listing-title">{{ $t('form.wayOfList') }}：</div>
                    <div class="listing-product" v-for="(checkItem, checkIndex) in subItem.detailList" :key="checkIndex">
                      <div class="checkout-custom">
                        <van-checkbox v-model="checkItem.isChoose" shape="square">{{ checkItem.type }}</van-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-more" @click="handleAdd('shelfList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
              <template v-if="brandSdMap[brandItem.projectId]">
                <div class="subset-form-item">
                  <div class="label required">
                    <span>{{ $t('shared.distributor') }}</span>
                  </div>
                  <div class="select-field custom-field" @click="toSelectStoreSd('shelfList', brandItem)">
                    {{ brandItem.expandInfo.sdList.map(item => item.sdName).join(',') }}
                  </div>
                </div>
                <div class="subset-form-item">
                  <div class="label">
                    <span>{{ $t('form.otherDistributor') }}</span>
                  </div>
                  <van-field v-model="brandItem.expandInfo.otherSd" placeholder="" :border="false" class="custom-field" />
                </div>
              </template>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.psi')" name="2">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.totalOpenSystemsSales') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="visitForm.totalOpenSales" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.totalDisposableSales') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="visitForm.totalDisposableSales" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
          <div class="form-item" v-for="subItem in brandSaleList" :key="subItem.id">
            <div class="label">
              <span>{{ subItem.projectName }} {{ $t('form.salesPcsWeek') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="subItem.sale" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.displayMerchandising')" name="3">
          <div v-for="(subItem, subIndex) in visitForm.materielList" :key="subIndex">
            <div class="form-item">
              <div class="label">
                <span>{{ subItem.materielName }}</span>
              </div>
              <van-field class="custom-field custom-radio-field">
                <template #input>
                  <van-radio-group v-model="subItem.isDisplayed" direction="horizontal">
                    <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
            <div class="form-item" v-if="![null, ''].includes(subItem.isDisplayed)">
              <div class="label">
                <span>{{ subItem.remarkName }}</span>
              </div>
              <van-field v-model="subItem.remark" placeholder="" :border="false" class="custom-field" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.photo') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.material" :after-read="(files, detail) => afterRead(files, detail, 'material')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.materialSampleDelivery')" name="4">
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.sampleDelivery') }}</span>
            </div>
            <div class="sample-delivry">
              <div class="main-header">
                <div class="left-header">
                  <span>{{ $t('form.total') }} </span>
                  <span class="total-num">{{ sampleListTotal }} </span>
                  <span>{{ $t('form.pcs') }}</span>
                </div>
                <div class="sell-out-btn" @click="toSelectSample">+ {{ $t('button.select') }}</div>
              </div>
              <div class="promotion-item" v-for="subItem in sampleList" :key="subItem.productId">
                <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
                <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
                <div class="info-item">
                  <div class="product-info">
                    <span class="product-name txt-ellipsis">{{ subItem.projectName }}·{{ subItem.productName }}</span>
                    <!-- <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" /> -->
                  </div>
                  <div class="material-inventory">
                    <span class="inventory-num txt-ellipsis">{{ $t('form.inv') }}：{{ subItem.inventoryCount }}</span>
                  </div>
                </div>
                <div class="stepper-custom">
                  <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                  <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                  <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                  <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                  <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.materialDelivery') }}</span>
            </div>
            <div class="material-delivery">
            <div class="main-header">
              <div class="left-header">
                <span>{{ $t('form.total') }} </span>
                <span class="total-num">{{ materialListTotal }} </span>
                <span>{{ $t('form.pcs') }}</span>
              </div>
              <div class="sell-out-btn" @click="toSelectMaterial">+ {{ $t('button.select') }}</div>
            </div>
            <div class="promotion-item" v-for="subItem in materialList" :key="subItem.id">
              <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
              <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
              <div class="info-item">
                <div class="product-info">
                  <span class="product-name txt-ellipsis">{{ subItem.materielName }}</span>
                  <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" />
                </div>
                <div class="material-inventory">
                  <div class="product-name-item" v-if="subItem.materielType === 1">
                    <div class="project-name universal-name">{{ subItem.projectName }}</div>
                    <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                  </div>
                  <div class="product-name-item" v-else>
                    <div class="project-name" v-for="proItem in subItem.productName.split(',')" :key="proItem">{{ proItem }}</div>
                    <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                  </div>
                </div>
              </div>
              <div class="stepper-custom">
                <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
              </div>
            </div>
          </div>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.materialSamplePhoto') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.deliveryMaterialProto" :after-read="(files, detail) => afterRead(files, detail, 'deliveryMaterialProto')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.storeServiceRecords')" name="5">
          <div class="sub-title">
            <div class="top-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div class="left-desc">{{ $t('form.afterSalesService') }}</div>
            </div>
          </div>
          <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.afterSaleList" :key="brandIndex">
             <div class="label square">
               <span>{{ brandItem.projectName }}</span>
             </div>
             <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
               <div class="product-sales">
                 <div class="product-mode">
                   <div class="mode-label">
                    <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                    <span>{{ $t('form.lssueDeviceMode') }}</span>
                   </div>
                   <XuSelect v-model="subItem.productId" :placeholder="$t('tips.pleaseSelectProduct')" :dataOptions="filteredOptions.afterSaleList(brandIndex, subItem.productId, brandItem.projectId)" :fieldNames="{label: 'productName', value: 'id'}" class="xu-custom-select" />
                   <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                 </div>
               </div>
               <div class="product-desc">
                 <div class="quantity-form">
                   <div class="form-label">{{ $t('form.afterSalesQuantityPcs') }}</div>
                   <div class="stepper-custom">
                     <div class="step-btn" @click="handleStep(-5, subItem, 'quantity')">-5</div>
                     <div class="step-btn" @click="handleStep(-1, subItem, 'quantity')">-</div>
                     <van-field class="step-value" v-model="subItem.quantity" type="digit" :border="false" />
                     <div class="step-btn" @click="handleStep(1, subItem, 'quantity')">+</div>
                     <div class="step-btn" @click="handleStep(5, subItem, 'quantity')">+5</div>
                   </div>
                 </div>
                 <div class="area-form">
                   <div class="form-label">{{ $t('form.lssusDescription') }}</div>
                   <van-field v-model="subItem.issueRemark" type="textarea" show-word-limit rows="3" class="custom-field field-textarea" />
                 </div>
               </div>
             </div>
             <div class="add-more" @click="handleAdd('afterSaleList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.servicePhoto') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.servicePhoto" :after-read="(files, detail) => afterRead(files, detail, 'servicePhoto')" />
          </div>
        </van-collapse-item>
        <van-collapse-item v-if="checkPer(['admin', 'app:visit:brandPrice'])" :title="$t('form.kOSGroupInvitation')" name="6">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.staffName') }}</span>
            </div>
            <van-field v-model="visitForm.invite.staffName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.kOSGroupJoinScreenshot') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.inviteUrl" :after-read="(files, detail) => afterRead(files, detail, 'inviteUrl')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.feedback')" name="7">
          <div class="form-item">
            <div class="label">
              <span></span>
            </div>
            <van-field v-model="visitForm.feedback" type="textarea" show-word-limit rows="3" placeholder="" class="custom-field field-textarea" />
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="visit-btn">
      <van-button class="submit-btn" @click="handleSubmit">{{ $t('button.submit') }}</van-button>
    </div>
    <VisitTip ref="visitTipRef" :currentVisitInfo="currentVisitInfo" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { Toast, Dialog } from 'vant'
import { arsVisitAddOrUpdateApi, arsVisitInfoApi } from '@/api/visit'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import { customerShelfGeneralApi, homeCurrentTimeApi } from '@/api/shared'
import VisitTip from './components/visitTip'
import i18n from '@/i18n'
const copyVisitForm = {
  id: '',
  customerId: '',
  lng: '',
  lat: '',
  inputAddress: '',
  visitTime: '', // moment(new Date()).format('YYYY-MM-DD'),
  isUpdateShelf: true,
  feedback: '',
  imgMap: {
    check: [],
    material: [],
    servicePhoto: [],
    deliveryMaterialProto: [],
    inviteUrl: []
  },
  invite: {
    staffName: ''
  },
  totalDisposableSales: '',
  totalOpenSales: '',
  brandSale: '',
  materielList: [
    { materielName: i18n.t('form.testingStationDisplayed'), isDisplayed: '', remarkName: i18n.t('form.testingStationProductModelNotes'), remark: '' },
    { materielName: i18n.t('form.posterDisplayed'), isDisplayed: '', remarkName: i18n.t('form.testingStationProductModelNotes'), remark: '' },
    { materielName: i18n.t('form.rollUpBannerOrFloorStandDisplay'), isDisplayed: '', remarkName: i18n.t('form.bannerFloorStandProductModelNotes'), remark: '' }
  ],
  afterSaleList: [],
  shelfList: []
}
export default {
  components: {
    XuSelect: () => import('@/components/XuSelect'),
    VisitTip
  },
  data () {
    return {
      activeNames: [],
      showCalendar: false,
      currentDate: new Date(),
      visitForm: {
        id: '',
        customerId: '',
        lng: '',
        lat: '',
        inputAddress: '',
        visitTime: '',
        isUpdateShelf: true,
        feedback: '',
        imgMap: {
          check: [],
          material: [],
          servicePhoto: [],
          deliveryMaterialProto: [],
          inviteUrl: []
        },
        invite: {
          staffName: ''
        },
        totalDisposableSales: '',
        totalOpenSales: '',
        brandSale: '',
        materielList: [
          { materielName: this.$t('form.testingStationDisplayed'), isDisplayed: '', remarkName: this.$t('form.testingStationProductModelNotes'), remark: '' },
          { materielName: this.$t('form.posterDisplayed'), isDisplayed: '', remarkName: this.$t('form.testingStationProductModelNotes'), remark: '' },
          { materielName: this.$t('form.rollUpBannerOrFloorStandDisplay'), isDisplayed: '', remarkName: this.$t('form.bannerFloorStandProductModelNotes'), remark: '' }
        ],
        afterSaleList: [],
        shelfList: []
      },
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      isUpdateShelfList: [
        { label: `${this.$t('shared.filter.needTo')}.`, value: true },
        { label: `${this.$t('shared.filter.notNeedTo')}.`, value: false }
      ],
      listingList: [
        { label: this.$t('form.listing'), value: 1 },
        { label: this.$t('form.notListing'), value: 0 },
        { label: this.$t('form.endOfSales'), value: -1 }
      ],
      result: [],
      copyDetailList: [],
      maxDate: new Date(),
      materialList: [],
      sampleList: [],
      currentVisitInfo: {},
      brandSaleList: [],
      shelfInfo: {}
    }
  },
  activated () {
    if (this.isNavigatingToSelect) {
      const materialDelivery = JSON.parse(window.localStorage.getItem('materialDelivery'))
      if (materialDelivery) {
        this.materialList = materialDelivery
        window.localStorage.removeItem('materialDelivery')
      }
    } else if (this.isNavigateToSampleSelect) {
      const sampleDelivery = JSON.parse(window.localStorage.getItem('sampleDelivery'))
      if (sampleDelivery) {
        this.sampleList = sampleDelivery
        window.localStorage.removeItem('sampleDelivery')
      }
    } else if (this.isNavigateToSdSelect) {
      const sdStoreSelect = JSON.parse(window.localStorage.getItem('sdStoreSelect'))
      if (sdStoreSelect) {
        this.visitForm[sdStoreSelect.typeKey].find(subItem => {
          if (subItem.projectId === sdStoreSelect.brandId) {
            subItem.expandInfo.sdList = sdStoreSelect.typeValue
            return subItem
          }
        })
        window.localStorage.removeItem('sdStoreSelect')
      }
    } else if (this.isNavigateToShelf) {

    } else {
      this.currentVisitInfo = {}
      this.activeNames = []
      this.visitForm = JSON.parse(JSON.stringify(copyVisitForm))
      this.materialList = []
      this.sampleList = []
      this.brandSaleList = []
      const { visitId = '', customerId = '' } = this.$route.query
      this.visitForm.id = visitId
      this.visitForm.customerId = customerId
      this.getMaterialProtoDelivery()
      this.initData()
    }
    this.isNavigatingToSelect = false
    this.isNavigateToSampleSelect = false
    this.isNavigateToSdSelect = false
    this.isNavigateToShelf = false
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/selectMaterial') {
      this.isNavigatingToSelect = true
    } else if (to.path === '/shared/selectSample') {
      this.isNavigateToSampleSelect = true
    } else if (to.path === '/shared/selectStoreSd') {
      this.isNavigateToSdSelect = true
    } else if (to.path === '/shared/shelfStatus') {
      this.isNavigateToShelf = true
    }
    next()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    materialListTotal () {
      return this.materialList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    filteredOptions () {
      const result = {
        shelfList: {},
        afterSaleList: {}
      }
      if (!this.globalData.productList) return result

      // Helper function to get options excluding other selected IDs
      const getOptionsForList = (list, currentId = null, projectId = null) => {
        const selectedIds = list.map(item => item.productId).filter(id => id && id !== currentId)
        return this.globalData.productList.filter(item => {
          // If it's a shelfList, it must match the projectId
          if (projectId && item.projectId !== projectId) {
            return false
          }
          // Include if it's the current item's ID or if it's not selected by others
          return !selectedIds.includes(item.id)
        })
      }

      // We need to return a function that looks up the correct array so we can pass currentId
      return {
        shelfList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.shelfList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        afterSaleList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.afterSaleList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        }
      }
    },
    brandSdMap () {
      const map = {}
      if (!this.visitForm.shelfList) return map
      this.visitForm.shelfList.forEach(brandItem => {
        map[brandItem.projectId] = brandItem.productList.some(subItem => {
          return subItem.productId && subItem.isShelf === 1 && subItem.detailList.some(detItem => detItem.type === 'Product On-sell(Distributor)' && detItem.isChoose)
        })
      })
      return map
    }
  },
  methods: {
    async getMaterialProtoDelivery () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      if (!this.visitForm.id) {
        arsProjectAppQueryListApi().then(res => {
          res.data.forEach(subItem => {
            this.visitForm.shelfList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [], expandInfo: { sdList: [], otherSd: '' } })
            this.visitForm.afterSaleList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [] })
            if (!subItem.sale) {
              subItem.sale = ''
            }
          })
          this.brandSaleList = res.data
        })
        homeCurrentTimeApi().then(res => {
          this.visitForm.visitTime = moment(res.data).format('YYYY-MM-DD')
        })
      }
      this.echoData()
    },
    handleCalendar () {
      // if (this.visitForm.id) return
      // this.showCalendar = true
    },
    handleAdd (type, params = {}) {
      const formeKey = params.productList
      const filterProduct = this.globalData.productList.filter(item => item.projectId === params.projectId)
      if (formeKey.length >= filterProduct.length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'afterSaleList') {
        params.productList.push({ productId: '', quantity: '', issueRemark: '' })
      } else if (type === 'shelfList') {
        params.productList.push({
          productId: '',
          isShelf: '',
          detailList: JSON.parse(JSON.stringify(this.copyDetailList))
        })
      }
    },
    handleDel (params, index) {
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    initData () {
      this.copyDetailList = []
      this.globalData.shelfType.forEach(subItem => {
        this.copyDetailList.push({ type: subItem.value, isChoose: false, quantity: '' })
      })
      if (!this.visitForm.id) {
        // this.visitForm.shelfList.forEach(item => {
        //   item.detailList = JSON.parse(JSON.stringify(this.copyDetailList))
        // })
        const currentTimeLoc =
          JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
        this.visitForm.lat = currentTimeLoc.lat
        this.visitForm.lng = currentTimeLoc.lng
        if (!currentTimeLoc.lat) return
        // 根据经纬度获取位置
        this.$nextTick(() => {
          new google.maps.Geocoder().geocode(
            {
              location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
            },
            (results, status) => {
              // 这里处理结果和上面一模一样
              if (status === google.maps.GeocoderStatus.OK) {
                this.visitForm.inputAddress = results[0].formatted_address
              } else {
                console.log('：error ' + status)
              }
            }
          )
        })
      }
    },
    onConfirmDate (date) {
      this.visitForm.visitTime = moment(date).format('YYYY-MM-DD')
      this.showCalendar = false
    },
    getFilteredOptions (listKey, currentId) {
      if (!this.globalData.productList) return []
      let selectedIds = []
      selectedIds = this.visitForm[listKey].map(item => item.productId).filter(id => id && id !== currentId)
      return this.globalData.productList.filter(item => !selectedIds.includes(item.id))
    },
    handleSubmit () {
      if (!this.visitForm.visitTime) {
        Toast(this.$t('tips.messageThirtyThree'))
        return
      }
      if (this.handleChecked()) {
        return
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const { imgMap } = this.visitForm
      const data = {
        ...this.visitForm,
        imgMap: {
          check: imgMap.check.map(subItem => subItem.url).join(','),
          material: imgMap.material.map(subItem => subItem.url).join(','),
          servicePhoto: imgMap.servicePhoto.map(subItem => subItem.url).join(','),
          deliveryMaterialProto: imgMap.deliveryMaterialProto.map(subItem => subItem.url).join(','),
          inviteUrl: imgMap.inviteUrl.map(subItem => subItem.url).join(',')
        },
        putMaterielList: this.materialList.map(subItem => { return { id: subItem.id, quantity: subItem.quantity } }),
        protoList: this.sampleList.map(subItem => { return { productId: subItem.productId, quantity: subItem.quantity } }),
        brandSaleList: this.brandSaleList,
        visitType: '0'
      }
      arsVisitAddOrUpdateApi(data).then(res => {
        Toast.clear()
        this.currentVisitInfo = res.data
        if (res.data.customerInfo.isAllot === 1) {
          this.$refs.visitTipRef.dialogShow = true
        } else {
          this.$router.go(-1)
        }
      })
    },
    async echoData () {
      if (this.visitForm.id) {
        const res = await arsVisitInfoApi(this.visitForm.id)
        Toast.clear()
        const { putMaterielList, protoList, brandSaleList, shelfList, materielList } = res.data
        materielList.forEach(subItem => {
          subItem.remarkName = ['Testing Station Displayed', 'Poster Displayed'].includes(subItem.materielName) ? 'Testing Station Product Model(Notes)' : subItem.materielName === 'Roll-up Banner or Floor Stand Display' ? 'Banner / Floor Stand Product Model(Notes)' : ''
        })
        shelfList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        Object.keys(this.visitForm).forEach(subItem => {
          if (subItem === 'imgMap') {
            this.visitForm[subItem].check = this.imgFormat(res.data[subItem].check)
            this.visitForm[subItem].material = this.imgFormat(res.data[subItem].material)
            this.visitForm[subItem].servicePhoto = this.imgFormat(res.data[subItem].servicePhoto)
            this.visitForm[subItem].deliveryMaterialProto = this.imgFormat(res.data[subItem].deliveryMaterialProto)
            this.visitForm[subItem].inviteUrl = this.imgFormat(res.data[subItem].inviteUrl)
          } else {
            this.visitForm[subItem] = res.data[subItem]
          }
        })
        putMaterielList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        protoList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        this.materialList = putMaterielList || []
        this.brandSaleList = brandSaleList
        this.sampleList = protoList
      } else {
        Toast.clear()
      }
      customerShelfGeneralApi(this.visitForm.customerId).then(res => {
        this.shelfInfo = res.data || {}
      })
    },
    imgFormat (arr) {
      let newArr = []
      if (arr.length > 0) {
        newArr = arr.split(',').map(subItem => {
          return { url: subItem }
        })
        return newArr
      } else {
        return []
      }
    },
    handleStep (delta, params, typeKey, obj = {}) {
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = params[typeKey] ? parseFloat(params[typeKey]) : 0
        newQuantity += delta
        if (newQuantity <= 0) newQuantity = 0
        this.$set(params, typeKey, newQuantity)
      }
    },
    handleQuantityInputBlur (item) {
      let newQuantity = Number(item.quantity) || 0
      if (newQuantity < 0) {
        newQuantity = 0
        this.$set(item, 'quantity', 0)
      }
      const newInventory = item.originalInventoryCount - newQuantity
      this.$set(item, 'inventoryCount', newInventory)
    },
    handleChecked () {
      let isFlag = false
      if (this.visitForm.imgMap.check.length <= 0) {
        Toast(this.$t('tips.checkInPhotoIsRequired'))
        isFlag = true
      }

      if (isFlag) {
        return isFlag
      }
      let shelftipsSingle = ''
      let shelfFlag = false
      if (this.visitForm.isUpdateShelf) {
        this.visitForm.shelfList.find(brandItem => {
          shelftipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
          if (brandItem.productList.length > 0) {
            shelfFlag = true
          }
          brandItem.productList.find(subItem => {
            if (!subItem.productId || (subItem.productId && subItem.isShelf === '')) {
              isFlag = true
              Toast(`${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`)
              return subItem
            }
            if (subItem.productId && subItem.isShelf === 1) {
              let detFlag = true
              shelftipsSingle = `${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`
              subItem.detailList.find(detItem => {
                if (this.checkPer(['admin', 'app:sd:visitInput']) && (detItem.isChoose && detItem.type === 'Product On-sell(Distributor)') && brandItem.expandInfo.sdList.length <= 0 && !brandItem.expandInfo.otherSd) {
                  shelftipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
                  detFlag = true
                  return detItem
                } else if (detItem.isChoose) {
                  detFlag = false
                }
              })
              if (detFlag) {
                isFlag = detFlag
                Toast(shelftipsSingle)
                return subItem
              }
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (!shelfFlag) {
          Toast(`${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`)
          isFlag = true
        }
      }
      if (!shelfFlag && isFlag) {
        return isFlag
      }
      this.visitForm.afterSaleList.find(brandItem => {
        brandItem.productList.find(subItem => {
          if (!subItem.productId || !subItem.quantity || !subItem.issueRemark) {
            isFlag = true
            Toast(`${this.$t('form.afterSalesService')} ${this.$t('tips.isRequired')}`)
            return subItem
          }
        })
        if (isFlag) {
          return brandItem
        }
      })
      return isFlag
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.visitForm.imgMap[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          this.visitForm.imgMap[key].splice(detail.index, 1)
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    toSelectMaterial () {
      if (this.materialList.length > 0) {
        window.localStorage.setItem('materialDelivery', JSON.stringify(this.materialList))
      }
      this.$router.push('/selectMaterial?pageType=visit')
    },
    toSelectSample () {
      if (this.sampleList.length > 0) {
        window.localStorage.setItem('sampleDelivery', JSON.stringify(this.sampleList))
      }
      this.$router.push('/shared/selectSample?pageType=expandVisit')
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    toSelectStoreSd (currKey, params) {
      window.localStorage.setItem('sdStoreSelect', JSON.stringify({ typeKey: currKey, typeValue: params.expandInfo.sdList || [], brandId: params.projectId }))
      this.$router.push('/shared/selectStoreSd')
    },
    toUrl (url) {
      if (!url) return
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.store-visit {
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .visit-form-content {
    // flex: 1;
    // overflow-y: auto;
    padding-bottom: 50px;
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0px 10px;
          padding-top: 10px;
        }
      }
      &::after {
        border: none;
      }
    }
    .collapse-sub {
      padding: 8px 0;
      margin-bottom: 10px;
      // border-bottom: 1px solid #e8effc;
      .sub-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .left-title {
          color: #333;
          font-weight: bold;
        }
      }
      .sub-bottom {
        display: flex;
        flex-wrap: wrap;
        .sub-listing-item {
          padding: 3px 5px;
          margin-right: 5px;
          margin-bottom: 3px;
          color: #50ad34;
          background-color: rgba(80, 173, 52, .2);
          border-radius: 5px;
          font-size: 12px;
        }
        .not-listing-item {
          color: #e79d42;
          background-color: rgba(231, 157, 66, .2);
        }
        .end-listing-item {
          color: #C4200B;
          background-color: rgba(196, 32, 11, .2);
        }
        .unknown-listing-item {
          color: #333;
          background-color: rgba(51, 51, 51, .2);
        }
      }
      .to-detail {
        margin-top: 10px;
        color: #307bff;
      }
    }
    .form-item,
    .subset-form-item {
      // padding: 0 10px;
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .label-bottom {
        padding-bottom: 8px;
        border-bottom: 1px solid #ebedf0;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .product-quantity {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .chiledren-label {
          margin-left: 16px;
          margin-right: 5px;
          font-size: 12px;
          color: #333;
        }
        .custom-xu-select {
          width: 166px;
        }
        .half-field {
          flex: 1;
        }
      }
      .product-sales {
        .product-mode {
          display: flex;
          align-items: center;
        }
        .mode-label {
          flex: 1;
          display: flex;
          align-items: center;
          margin-right: 10px;
          font-size: 12px;
          color: #333;
          .jt-icon {
            width: 9px;
            height: 12px;
            margin-right: 5px;
          }
        }
        .xu-custom-select {
          width: 180px;
        }
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .product-desc {
        margin: 10px 0;
        padding: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .quantity-form {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .quantity-form,
        .area-form {
          .form-label {
            font-size: 12px;
            color: #7f7f7f;
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
        }
        .area-form {
          margin-top: 8px;
        }
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          padding-bottom: 5px;
          border-bottom: 1px solid #ebedf0;
          .listing-label {
            padding-bottom: 5px;
            font-size: 12px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            // padding: 6px 0;
            background-color: #f7f7f7;
            // /deep/.van-radio__label {
            //   color: #7f7f7f;
            // }
          }
        }
        .listing-title {
          font-size: 13px;
          margin-top: 10px;
          color: #7f7f7f;
        }
        .checkout-custom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          font-size: 12px;
          /deep/.van-checkbox__label {
            color: #7f7f7f;
          }
          .total-pcs {
            color: #307bff;
          }
        }
      }
      .stepper-custom {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      /deep/.van-uploader {
        .van-uploader__upload {
          width: 60px;
          height: 60px;
        }
        .van-uploader__preview-image {
          width: 60px;
          height: 60px;
        }
      }
      .select-field {
        display: flex;
        align-items: center;
        min-height: 36px;
        color: #333;
      }
    }
    .subset-form-item {
      padding: 0;
    }
    .listing-form-item {
      padding-bottom: 10px;
      margin-bottom: 26px;
      border-bottom: 3px solid #e8effc;
      .shelf-radio {
        .van-radio-group {
          flex-direction: column;
          .van-radio {
            margin-bottom: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .no-listing-form-item {
      border-bottom: none;
    }
    .shelf-title {
      font-size: 13px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
    .shelf-bc {
      padding: 10px 0;
      background-color: rgba(228, 231, 235, .3);
      .form-item:last-child {
        margin-bottom: 0px;
      }
    }
    .sub-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0px;
      border-bottom: 1px solid #e8effc;
      font-size: 12px;
      margin-bottom: 10px;
      .total-right {
        color: #333;
      }
      .top-title {
        display: flex;
        font-weight: bold;
        color: #000;
        font-size: 12px;
        .ell-icon {
          margin-top: 2px;
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
    }
    .uploader-customer {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      .label {
        align-self: flex-start;
      }
    }
    .sell-in-quantity {
      margin-bottom: 43px;
    }
    .form-time-item {
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-top: 10px;
      .label {
        margin-right: 10px;
        margin-bottom: 0;
      }
      .custom-field {
        flex: 1;
      }
    }
    .add-more {
      display: inline-block;
      padding: 5px;
      font-size: 12px;
      color: #307bff;
      border: 1px solid #307bff;
      background-color: #e4eefc;
      border-radius: 6px;
      margin-bottom: 10px;
    }
    .custom-label {
      display: flex;
      align-items: center;
      .label-icon {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }
    .psi-section {
      margin: 10px;
      margin-top: 0;
      padding: 50px 60px;
      text-align: center;
      background-color: #f7f7f7;
      border-radius: 10px;
      color: #333;
      font-size: 12px;
    }
    .sample-delivry,
    .material-delivery {
      color: #333;
      margin-bottom: 10px;
      .main-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-top: 1px solid #e8effc;
        border-bottom: 2px solid #e8effc;
        font-size: 12px;
        .total-num {
          font-size: 14px;
          font-weight: bold;
          color: #307bff;
        }
        &:first-child {
          border-top: none;
        }
      }
      .sell-out-btn {
        height: 23px;
        line-height: 23px;
        padding: 0px 3px;
        background-color: #e8effc;
        border-radius: 5px;
        font-size: 11px;
        border: 1px solid #307bff;
        color: #307bff;
      }
      .promotion-item {
        display: flex;
        align-items: center;
        padding: 10px 6px;
        border-bottom: 1px solid #b9cbed;
        font-size: 12px;
        .icon-img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          object-fit: contain;
        }
        .info-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 40px;
          .product-info {
            display: flex;
            align-items: center;
          }
          .product-name {
            max-width: 136px;
            font-size: 13px;
          }
          .material-inventory {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .product-name-item {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
            .project-name {
              padding: 1px 3px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
              margin-bottom: 3px;
              font-size: 10px;
            }
            .universal-name {
              border: 1px solid #34b032;
              color: #34b032;
            }
            .inventory-num {
              flex: 1;
            }
          }
        }
        .stepper-custom {
          display: flex;
          align-items: center;
          border: 1px solid #b9cbed;
          border-radius: 4px;
          overflow: hidden;
          .step-btn {
            width: 28px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            color: #323233;
            cursor: pointer;
            border-right: 1px solid #b9cbed;;
            font-size: 12px;
            &:last-child {
              border-right: none;
            }
            &:active {
              background-color: #f2f3f5;
            }
          }
          .step-value {
            width: 32px;
            height: 24px;
            padding: 0;
            background-color: #fff;
            border-right: 1px solid #b9cbed;
            border-radius: 0;
            /deep/ .van-field__control {
              text-align: center;
              height: 24px;
              line-height: 24px;
              color: #323233;
              font-size: 12px;
            }
          }
        }
      }
      .product-item {
        display: flex;
        align-items: center;
        padding: 10px 6px;
        border-bottom: 1px solid #e8effc;
        color: #000;
        .material-basc-info {
          display: flex;
          align-items: center;
          .icon-img {
            width: 40px;
            height: 40px;
            object-fit: contain;
          }
          .info-item {
            margin-left: 6px;
          }
          .title-txt {
            width: 90px;
            font-size: 12px;
            margin-bottom: 14px;
          }
          .subtitle-txt {
            display: flex;
            align-items: center;
            .product-type {
              padding: 0px 2px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
            }
          }
        }
        .sample-basc-info {
          width: 143px;
          font-size: 12px;
        }
        .sell-in-info {
          display: flex;
          justify-content: center;
          align-items: center;
          .plus-btn,
          .minus-btn {
            width: 23px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #323233;
            border: 1px solid #b9cbed;
            margin-right: 3px;
            font-size: 10px;
          }
          .input-field {
            width: 30px;
          }
          /deep/.van-cell {
            padding: 0;
            font-size: 12px;
            border: 1px solid #dce5f6;
            input {
              padding-left: 2px;
            }
          }
        }
      }
    }
  }
  .visit-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    .submit-btn {
      width: 100%;
      background-color: #307bff;
      color: #fff;
      font-weight: bold;
    }
  }
}
.collapse-title-reuqired {
  color: #ff4444;
  margin-right: 5px;
}
</style>
